import React, { Component } from 'react';
import { BasicHeader } from '../../../components/basic_header';
import { Spin } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import DatatypeAdd from './datatype_add';

class DatatypeEdit extends Component {
    constructor(props) {
        super(props)

        this.datatype_id = props.match.params.datatype_id;
        this.group_id = props.match.params.group_id;


        this.state = {
            edit_data: {},
            edit_id: null,
            loading: true
        }


        this.datatype_detail = RESTExecutor.detail().config({
            label: 'data_types_detail',
        }).forId(this.datatype_id).callbacks((success) => {


            this.setState({ loading: false, edit_data: success.result, edit_id: success.result.id })

        }, (error) => {
            this.setState({ loading: false })

        }).connect(props.domains.datatype);

        this.datatype_detail.execute()



    }

    render() {
        const { edit_data, edit_id, loading } = this.state;
        let datatype_detail_resp = this.datatype_detail.response();

        if (loading) {
            return <center><Spin /></center>
        }
        return (
            <ErrorWrapper error={datatype_detail_resp}
                onReload={() => {
                    this.setState({ loading: true, edit_id: null });
                    this.datatype_detail.forId(this.datatype_id).execute();
                }}>
                <DatatypeAdd
                    edit_data={edit_data}
                    edit_id={edit_id}
                    key={`${edit_id}--`}
                    match={{
                        params:{
                            group_id:this.group_id
                        }
                    }}
                    history={this.props.history}
                />

            </ErrorWrapper>
        );
    }

    componentWillReceiveProps(nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;



        if (olddatatype_id !== newdatatype_id) {
            this.datatype_id = newdatatype_id;
            this.group_id = nextProps.match.params.group_id;


            this.setState({
                loading: true
            }, () => {
                this.datatype_detail.forId(this.datatype_id).execute()
            })

        }
    }
}

export default withDomains(DatatypeEdit,"datatype");
